class MovingBlockTab extends HTMLElement {
  constructor() {
    super();
    this.ul = this.querySelector("ul");
    this.lis = this.querySelectorAll("li");
    this.track = this.querySelector(".track");
    this.navNext = this.querySelector("button.nav.next");
    this.navPrev = this.querySelector("button.nav.prev");
    this.activeBulletPadding = this.style.getPropertyValue(
      "--active-bullet-padding"
    );
  }
  connectedCallback() {
    this.lis.forEach((li, index) => {
      if (index === 0) {
        this.setActive(li.querySelector("button"), true);
      }
      li.addEventListener("click", (e) => {
        // console.log("li", li, e.target.offsetLeft, e.target.offsetTop);

        if (e.target.tagName === "BUTTON") {
          this.clearActive();
          e.stopPropagation();
          this.setActive(e.target);
          this.dispatchEvent(
            new CustomEvent(
              "moving-block-tab:switch",
              {
                detail: {
                  index,
                },
              },
              {
                bubbles: true,
              }
            )
          );
        }
      });
    });
    this.checkScrollable();
    window.addEventListener("resize", () => {
      this.checkScrollable();
    });
    this.navNext.addEventListener("click", (e) => {
      this.track.scrollBy({
        left: this.track.clientWidth / 2,
        behavior: "smooth",
      });
    });
    this.navPrev.addEventListener("click", (e) => {
      this.track.scrollBy({
        left: -1 * this.track.clientWidth / 2,
        behavior: "smooth",
      });
    });

    this.track.addEventListener("scroll", () => {
      console.log(
        "scroll left",
        this.track.scrollLeft,
        this.track.clientWidth,
        this.track.scrollLeft + this.track.clientWidth,
        this.track.scrollWidth
      );
      if (
        this.track.scrollLeft + this.track.clientWidth >=
        this.track.scrollWidth - 1
      ) {
        this.navNext.classList.add("opacity-0");
      } else {
        this.navNext.classList.remove("opacity-0");
      }

      if (this.track.scrollLeft <= 0) {
        this.navPrev.classList.add("opacity-0");
      } else {
        this.navPrev.classList.remove("opacity-0");
      }
    });
  }
  checkScrollable() {
    if (this.track.scrollWidth > this.track.clientWidth) {
      this.classList.add("scrollable");
    } else {
      this.classList.remove("scrollable");
    }
  }
  clearActive() {
    for (let li of this.lis) {
      if (li.classList.contains("active")) {
        li.classList.remove("active");
        break;
      }
    }
  }
  setActive(target,noScroll= false) {
    const activeBulletPadding = this.style.getPropertyValue(
      "--active-bullet-padding"
    );
    this.style.setProperty("--active-left", target.offsetLeft + "px");
    this.style.setProperty("--active-top", target.offsetTop + "px");
    this.style.setProperty(
      "--active-width",
      `calc(${target.offsetWidth}px - 1px + ${activeBulletPadding} * 2)`
    );
    if(!noScroll) {
      target.closest("li").scrollIntoView({ behavior: "smooth", inline: "center" });
    }

    // if((target.offsetLeft - activeBulletPadding) > this.track.scrollLeft + this.track.clientWidth) {

    //   this.track.scrollBy({
    //       left: target.offsetLeft - activeBulletPadding - this.track.scrollLeft ,
    //       behavior: "smooth"
    //     });
    //   }
    if (!target.hasAttribute("data-tab-item")) {
      target.closest("[data-tab-item]").classList.add("active");
    } else {
      target.classList.add("active");
    }
    // console.log("this.activeBullutPadding", activeBulletPadding);
  }
}
if (!customElements.get("moving-block-tab")) {
  customElements.define("moving-block-tab", MovingBlockTab);
}
